import React from 'react';

const SvgSuccessIcon = props => (
  <svg
    data-name="ic_success"
    width={props.size || 97.959}
    height={props.size || 97.959}
    viewBox="0 0 97.959 97.959"
    fill="#18cc48"
    {...props}
  >
    <path
      d="M48.979 0a48.979 48.979 0 1048.98 48.979A49.035 49.035 0 0048.979 0zm0 94.191a45.212 45.212 0 1145.212-45.212 45.264 45.264 0 01-45.212 45.212z"
      className="alert_success_svg__cls-1"
      data-name="Trazado 247"
    />
    <path
      d="M72.06 28.89L43.106 61.457 25.665 47.508a1.884 1.884 0 00-2.353 2.943l18.839 15.07a1.886 1.886 0 002.586-.22l30.141-33.909a1.884 1.884 0 00-2.818-2.5z"
      className="alert_success_svg__cls-1"
      data-name="Trazado 248"
    />
  </svg>
);

export default SvgSuccessIcon;
